<template>
  <div class="pratkowieckalech">
    <header>
      <div class="container">
        <div class="headerBar f f-col f-jbetween">
          <LogoWhite v-bind:dark="false" size="m" :pratkowiecka="true" />
          <NavigationList
            v-if="!isMobile"
            :menuItems="menuItems"
            :socialMedia="socialMedia"
          />
        </div>
      </div>
    </header>
    <main>
      <JumbotronWithSlider :slides="slides" />

      <section id="about" class="about_office">
        <div class="container">
          <ServicesList
            :servicesList="aboutList"
            :showNumber="true"
            :withDot="true"
          />
        </div>
      </section>

      <section id="services" class="services_office">
        <div class="container">
          <ServicesList
            :servicesList="servicesList"
            :boldHeader="true"
            :switchButton="true"
            :translations="translations"
          />
        </div>
      </section>

      <section v-if="false" class="newsContainer d-f">
        <div class="container">
          <News :news="news" />
        </div>
      </section>

      <section id="about_me" class="us">
        <Us :people="people" />
      </section>

      <ContactForm :hideCircles="true" :contactForm="contactForm" />
    </main>

    <Footer
      :socialMedia="socialMedia"
      :footerInformations="footerInformations"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueMeta from "vue-meta";

Vue.use(VueMeta);

import LogoWhite from "@/components/svg/LogoWhite";
import Us from "@/components/Us";
import ContactForm from "@/components/pratkowiecka/ContactForm";
import NavigationList from "@/components/NavigationList";
import ServicesList from "@/components/ServicesList";
import News from "@/components/News";
import Footer from "@/components/Footer";
import JumbotronWithSlider from "@/components/pratkowieckalech/JumbotronWithSlider";

export default {
  name: "PratkowieckaLech",
  components: {
    ContactForm,
    NavigationList,
    ServicesList,
    Us,
    News,
    Footer,
    JumbotronWithSlider,
    LogoWhite,
  },
  metaInfo() {
    return this.meta;
  },
  mounted() {
    this.setIsMobile();
    this.setFavicon("pratkowieckalech_favicon.ico");
  },
  data: () => {
    return {
      meta: {
        title: "Adwokat Marta Pratkowiecka-Duszak",
        htmlAttrs: {
          lang: "pl",
        },
        meta: [
          {
            vmid: "description",
            name: "description",
            content: "Nowoczesna Kancelaria z siedzibą w sercu Wrocławia",
          },
        ],
      },
      translations: {
        showMore: "więcej",
        showLess: "mniej",
      },
      slides: [
        {
          text: "Zapraszam do kancelarii w centrum Wrocławia.",
          buttonText: "Usługi",
          buttonLink: "#services",
        },
        {
          text: "Zapewniam profesjonalne wsparcie i troskę o Twoje sprawy.",
          buttonText: "O mnie",
          buttonLink: "#about",
        },
        {
          text: "Pomagam rozwiązać sytuacje konfliktowe.",
          buttonText: "Skontaktuj się",
          buttonLink: "#contact",
        },
      ],
      menuItems: [
        {
          goTo: "about",
          class: "uppercase",
          text: "O kancelarii",
        },
        {
          goTo: "services",
          class: "uppercase",
          text: "Usługi",
        },
        {
          goTo: "about_me",
          class: "uppercase",
          text: "O mnie",
        },
        {
          goTo: "contact",
          class: "uppercase",
          text: "Kontakt",
        },
      ],
      aboutList: {
        header: "O kancelarii",
        list: [
          {
            text: "Prowadzę kancelarię z siedzibą we Wrocławiu, ale świadczę usługi na terenie całego województwa dolnośląskiego. Zapraszam również na konsultacje online.",
          },
          {
            text: "Zapewniam rzetelne przygotowanie do procesu sądowego. W prosty sposób tłumaczę skomplikowaną procedurę dbając, by klient czuł się zaopiekowany i pewny siebie w kontaktach z sądem i przeciwnikiem procesowym.",
          },
          {
            text: "Gwarantuję dyskrecję, empatię i zrozumienie dla Twoich problemów. Działam zawsze w interesie klienta, walcząc o najkorzystniejsze dla niego rozwiązanie.",
          },
          {
            text: "Na bieżąco przekazuję klientom wszystkie informacje i zapewniam bieżący dostęp do stanu sprawy. Cenię sobie transparentność i jasne zasady współpracy.",
          },
          {
            text: "Stale poszerzam swoją wiedzę i kompetencje. Jestem otwarta na nowe rozwiązania i pozasądowe metody rozwiązywania sporów.",
          },
          {
            text: "Priorytetem jest dla mnie jak najszybsze i możliwie najmniej stresujące rozwiązanie problemów moich klientów.",
          },
        ],
      },
      servicesList: {
        header: "Usługi",
        list: [
          {
            text: "Prawo karne",
            exerpt:
              "W sprawach karnych bronię osób oskarżonych o popełnienie czynów zabronionych, jak również pokrzywdzonych przestępstwem.",
            paragraph:
              "W sprawach karnych bronię osób oskarżonych o popełnienie czynów zabronionych, jak również pokrzywdzonych przestępstwem. Działam na wszystkich etapach postępowania karnego, zapewniając klientom dyskrecję, rzetelność i zaangażowanie w ich sprawy. Wiem, że postępowanie karne wiąże się z ogromnym stresem i jestem świadoma jego konsekwencji dla moich klientów, dlatego pracuję w sposób szybki, zdecydowany i jednocześnie wyważony. W sprawach nagłych (zatrzymanie) proszę o kontakt telefoniczny. Działanie obrońcy od początku postępowania zapewnia ochronę praw i interesów zatrzymanego, stanowi też wsparcie dla jego osób najbliższych, pozwala uniknąć nagłych i nieprzemyślanych decyzji procesowych. ",
          },
          {
            text: "Prawo rodzinne",
            exerpt:
              "Sprawy rodzinne wymagają nie tylko wiedzy prawniczej, ale również wyjątkowej empatii, delikatności, zaangażowania i wsłuchania się w problemy klienta.",
            paragraph:
              "Sprawy rodzinne wymagają nie tylko wiedzy prawniczej, ale również wyjątkowej empatii, delikatności, zaangażowania i wsłuchania się w problemy klienta. Zapewniam spokojną, bezpieczną atmosferę podczas rozmów i prowadzenia spraw oraz wsparcie i zrozumienie w najtrudniejszych życiowych momentach. Prowadzę sprawy o rozwód, separację, podział majątku, ustanowienie rozdzielności majątkowej, jak również sprawy związane z władzą rodzicielską, kontaktami z dziećmi, alimentami czy przysposobieniem. Zapewniam natychmiastową pomoc ofiarom przemocy domowej we wszystkich jej aspektach.",
          },
          {
            text: "Kredyty frankowe",
            exerpt:
              "Reprezentuję klientów w sprawach dotyczących kredytów indeksowanych lub denominowanych do franka szwajcarskiego (CHF).",
            paragraph:
              "Reprezentuję klientów w sprawach dotyczących kredytów indeksowanych lub denominowanych do franka szwajcarskiego (CHF). Prowadzę postępowania sądowe zmierzające do ustalenia nieważności umów kredytowych i odzyskania wpłaconych przez kredytobiorców rat kredytu. W toku procesu wnioskuję o udzielenie zabezpieczenia poprzez zawieszenie płatności bieżących rat kredytowych. Dokonuję analizy umowy i przygotowuję klientów do rozpraw, śledzę najnowsze orzecznictwo dotyczące kredytów frankowych i stale poszerzam prezentowaną argumentację.",
          },
          {
            text: "Mediacje i negocjacje",
            exerpt:
              "Towarzyszę klientom w czasie rozmów ugodowych, mediacji i negocjacji.",
            paragraph:
              "Towarzyszę klientom w czasie rozmów ugodowych, mediacji i negocjacji. Jestem otwarta na rozmowę, wymianę argumentów, kompromisy i nowatorskie rozwiązania. Nie zmierzam za wszelką cenę do sporu sądowego i jeśli to możliwe zawsze dążę do polubownego zakończenia sprawy.",
          },
          {
            text: "Prawo pracy",
            exerpt:
              "Dla wielu osób stosunek pracy stanowi źródło utrzymania i relację, w której pozostają przez znaczną część życia.",
            paragraph:
              "Dla wielu osób stosunek pracy stanowi źródło utrzymania i relację, w której pozostają przez znaczną część życia. Zarówno pracownicy jak i pracodawcy dysponują szeregiem praw, ale ciąży na nich również wiele obowiązków. Pracodawcom służę pomocą w przygotowaniu i wdrożeniu m. in. umów o pracę, czy dokumentacji zmierzającej do zmiany lub rozwiązania umowy o pracę. Pracownikom oferuję w szczególności usługi w zakresie realizacji uprawnień związanych z rodzicielstwem oraz niezbędną pomoc w razie niezgodnego z prawem rozwiązania stosunku pracy.",
          },
          {
            text: "Odszkodowanie i zadośćuczynienie",
            exerpt:
              "Z powodzeniem prowadzę postępowania o zadośćuczynienie i odszkodowanie za poniesioną szkodę i doznaną krzywdę.",
            paragraph:
              "Z powodzeniem prowadzę postępowania o zadośćuczynienie i odszkodowanie za poniesioną szkodę i doznaną krzywdę. Brałam udział w precedensowych sprawach dotyczących zadośćuczynienia dla członków najbliższej rodziny poszkodowanego, który na skutek czynu niedozwolonego doznał ciężkiego i trwałego uszczerbku na zdrowiu, wygrywając dla klientów bardzo wysokie kwoty. Pomagam w uzyskaniu odszkodowania i zadośćuczynienia za uszkodzenie ciała, zadośćuczynienia za śmierć osoby najbliższej, renty, odpowiedniej kwoty z OC sprawcy z tytułu uszkodzenia pojazdu.",
          },
          {
            text: "Ochrona dóbr osobistych",
            exerpt:
              "Doradzam w sprawach związanych z ochroną wizerunku, prywatności oraz dobrego imienia, jak również wolności słowa i wypowiedzi artystycznej.",
            paragraph:
              "Doradzam w sprawach związanych z ochroną wizerunku, prywatności oraz dobrego imienia, jak również wolności słowa i wypowiedzi artystycznej. W tym zakresie pomagam zarówno osobom fizycznym jak i prawnym, analizuję publikacje we wszystkich środkach masowego przekazu i mediach społecznościowych. Pomagam ofiarom naruszeń, jak również tym, których działanie mogło zagrozić lub naruszyć dobra osobiste innych podmiotów. Reprezentuję klientów zarówno w sprawach cywilnych jak i karnych dotyczących zniesławienia, znieważenia, czy utrwalania i wykorzystania wizerunku.",
          },
          {
            text: "Prawo własności intelektualnej",
            exerpt:
              "Rozwój nowych technologii, możliwych form artystycznego wyrazu i pól eksploatacji, a także różnorodność dostępnych na rynku towarów i usług rodzi coraz częściej konieczność ochrony autorskich praw majątkowych i osobistych.",
            paragraph:
              "Rozwój nowych technologii, możliwych form artystycznego wyrazu i pól eksploatacji, a także różnorodność dostępnych na rynku towarów i usług rodzi coraz częściej konieczność ochrony autorskich praw majątkowych i osobistych, ochrony wizerunku czy zwalczania nieuczciwej konkurencji, w szczególności w ramach ochrony tajemnicy przedsiębiorstwa, podobieństwa produktów i oznaczeń, czy nieuczciwego posługiwania się renomą. Doradzam w zakresie prawa autorskiego i praw pokrewnych, prawa patentowego i znaków towarowych, przygotowuję i konsultuję umowy dotyczące przenoszenia autorskich praw majątkowych, umowy licencyjne czy umowy o zachowanie poufności. Zapewniam pełną obsługę instytucjom i ośrodkom kultury, przedsiębiorcom, artystom, naukowcom. Konsultuję legalność podejmowanych działań i poszukuję najbardziej optymalnych rozwiązań.",
          },
          {
            text: "Prawo medyczne",
            exerpt:
              "Prowadzę sprawy karne dotyczące błędów medycznych, jak również sprawy cywilne o zadośćuczynienie i odszkodowanie za szkody związane z nieprawidłowym przeprowadzeniem leczenia szpitalnego.",
            paragraph:
              "Prowadzę sprawy karne dotyczące błędów medycznych, jak również sprawy cywilne o zadośćuczynienie i odszkodowanie za szkody związane z nieprawidłowym przeprowadzeniem leczenia szpitalnego, zabiegu z zakresu medycyny estetycznej i stomatologii czy naruszeniem praw pacjenta. Jestem gotowa pełnić funkcję obrońcy lekarzy w sprawach karnych oraz w postępowaniach dyscyplinarnych prowadzonych, w ramach Izb Lekarskich przed Sądami Lekarskimi. Zastępujemy klientów również w postępowaniach przed Wojewódzkimi Komisjami ds. Orzekania o Zdarzeniach Medycznych. Podejmujemy się reprezentacji osób pokrzywdzonych błędami medycznymi także w postępowaniach karnych.",
          },
        ],
      },
      news: {
        header: "Aktualności",
        news: [
          {
            header: "Corporate Power Purchase Agreement (PPA)",
            date: "19.09.2019",
            paragraph:
              "Aliquam efficitur nec metus quis venenatis. Vestib ulum lobortis eu purus et venenatis. Sed elemtum commodo pharetra. Mauris a ex dolor. Quisque non accumsan erat. Phasellus non aliquet erat. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc feugiat pellentesque veli.",
          },
          {
            header: "Corporate Power Purchase Agreement (PPA)",
            date: "19.09.2019",
            paragraph:
              "Aliquam efficitur nec metus quis venenatis. Vestib ulum lobortis eu purus et venenatis. Sed elemtum commodo pharetra. Mauris a ex dolor. Quisque non accumsan erat. Phasellus non aliquet erat. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc feugiat pellentesque veli.",
          },
          {
            header: "Corporate Power Purchase Agreement (PPA)",
            date: "19.09.2019",
            paragraph:
              "Aliquam efficitur nec metus quis venenatis. Vestib ulum lobortis eu purus et venenatis. Sed elemtum commodo pharetra. Mauris a ex dolor. Quisque non accumsan erat. Phasellus non aliquet erat. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc feugiat pellentesque veli.",
          },
        ],
      },
      people: [
        {
          name: "Marta Pratkowiecka - Duszak",
          role: "adwokat",
          paragraphs: [
            "Adwokat Marta Pratkowiecka - Duszak specjalizuje się w sprawach z zakresu prawa rodzinnego i karnego. Z sukcesami działa jako obrońca w postępowaniach karnych, reprezentuje także osoby pokrzywdzone przestępstwem. Doradza Klientom również w zakresie prawa cywilnego, prawa własności intelektualnej i prawa pracy. ",
            "Adwokat Marta Pratkowiecka - Duszak uzyskała najwyższy wynik z zawodowego egzaminu adwokackiego w Izbie Adwokackiej we Wrocławiu. Jest wpisana na listę stałych mediatorów prowadzoną przez Prezesa Sądu Okręgowego we Wrocławiu.",
            "Absolwentka Wydziału Prawa, Administracji i Ekonomii Uniwersytetu Wrocławskiego oraz doktorantka w Katedrze Postępowania Karnego WPAiE UWr. Autorka publikacji z zakresu procesu karnego. Absolwentka Studiów Podyplomowych Prawa Własności Intelektualnej na Uniwersytecie Jagiellońskim. ",
            "Prywatnie miłośniczka literatury, filmu, podróży i sportu.",
          ],
          telephone: "605 205 325",
          email: "kancelaria@pratkowiecka.pl",
          image: require("@/assets/Marta_Pratkowiecka_portret.jpg"),
          imageClass: "left",
        },
      ],
      socialMedia: {
        Facebook: {
          link: "https://www.facebook.com/pratkowiecka",
        },
        Linkedin: {
          link: "https://www.linkedin.com/in/marta-pratkowiecka-duszak-715b6a194/",
        },
      },
      contactForm: {
        address: [
          "ul. Wita Stwosza 3 lok. 316 ",
          "50 - 148 Wrocław",
          "tel. 605 205 325",
        ],
        email: "kancelaria@pratkowiecka.pl",
        writeMe: "Napisz do mnie",
        showMap: true,
      },
      footerInformations: [
        [
          {
            text: "Kancelaria Adwokacka",
          },
          {
            class: "marginBottom",
            text: "Adwokat Marta Pratkowiecka - Duszak",
          },
          {
            text: "ul. Wita Stwosza 3 lok. 316",
          },
          {
            text: "50 - 148 Wrocław",
          },
          {
            text: "NIP 691 247048 3",
          },
          {
            text: "tel. 605 205 325",
          },
        ],
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "scss/app";
@import "scss/_utils";
@import url("https://fonts.googleapis.com/css?family=Rubik:400,500,700&display=swap&subset=latin-ext");

body {
  background: white !important;
  font-family: "Rubik", sans-serif;
}

.headerBar {
  color: white;
  font-size: 12px;
}

section {
  z-index: 1;
  position: relative;
}

section h3 {
  font-size: 16px;
}

section h2 {
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 14px;
}

.pratkowieckalech {
  background: #12202f;
  color: white;
}

.about {
  background-color: $blue !important;
}

.pro_bono {
  padding-top: 115px;
  padding-bottom: 115px;
}

@include mobile() {
  section.us {
    padding-top: 32px;
    padding-bottom: 32px;
  }
}

@include desktop() {
  section.us {
    padding-top: 115px;
    padding-bottom: 185px;
  }
}

section.us .row {
  width: 100%;
}

.services_office {
  padding-top: 115px;
  padding-bottom: 115px;
  background: white;
  color: $blue;
}

.newsContainer {
  min-height: 40vh;
}

.copy {
  min-height: 50vh;
}
</style>
